// extracted by mini-css-extract-plugin
export default {"primaryBrown":"#747048","darkCream":"#e7e1cf","lightCream":"#edece8","footerLight":"#f4ece0","darkGrey":"#2d2c27"};